import React from "react";

/** Catalog preview icon for L-shaped turn stairs. */
export const TurnStairsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 100 100"
    fill="none"
    stroke="currentColor"
    strokeWidth="4"
    strokeLinecap="square"
    strokeLinejoin="miter"
    width="100%"
    height="100%"
    {...props}
  >
    {/* L-shaped outer frame */}
    <path d="M 22 82 L 22 18 L 82 18 L 82 48 L 52 48 L 52 82 Z" />

    {/* Vertical flight treads */}
    <line x1="22" y1="65" x2="52" y2="65" />
    <line x1="22" y1="48" x2="52" y2="48" />

    {/* Landing divider and horizontal flight treads */}
    <line x1="52" y1="18" x2="52" y2="48" />
    <line x1="67" y1="18" x2="67" y2="48" />
  </svg>
);
